import axios from 'axios';
import tokenManager from './tokenManager';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

// Request interceptor: Token an Header hängen
api.interceptors.request.use(
    (config) => {
        const token = tokenManager.getToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor: Automatischen Refresh bei 401
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // 403: Keine Berechtigung → Event feuern, Komponenten reagieren selbst
        if (error.response?.status === 403) {
            window.dispatchEvent(new CustomEvent('forbidden'));
            return Promise.reject(error);
        }

        // Falls 401 und noch nicht versucht zu refreshen
        if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url.includes('/auth/login') && !originalRequest.url.includes('/auth/register')) {
            originalRequest._retry = true;
            const refreshToken = tokenManager.getRefreshToken();

            // Wenn kein Refresh-Token vorhanden, direkt abmelden
            if (!refreshToken) {
                tokenManager.clearTokens();
                window.location.href = '/auth';
                return Promise.reject(error);
            }

            // Wenn gerade ein Refresh läuft, auf diesen warten
            if (tokenManager.getIsRefreshing()) {
                return new Promise((resolve, reject) => {
                    tokenManager.subscribeTokenRefresh((newToken) => {
                        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                        resolve(api(originalRequest));
                    });
                });
            }

            // Refresh starten
            tokenManager.setRefreshing(true);

            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/refresh`, {
                    refreshToken: refreshToken
                });

                if (response.status === 200) {
                    const { token: newToken, refreshToken: newRefreshToken } = response.data;

                    // Token speichern
                    tokenManager.setTokens(newToken, newRefreshToken);

                    // Alle wartenden Subscriber benachrichtigen
                    tokenManager.onRefreshed(newToken);
                    tokenManager.setRefreshing(false);

                    // Ursprüngliche Anfrage mit neuem Token wiederholen
                    originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                    return api(originalRequest);
                }
            } catch (refreshError) {
                console.error("Refresh-Token abgelaufen oder ungültig", refreshError);
                tokenManager.clearTokens();
                tokenManager.onRefreshFailed();
                tokenManager.setRefreshing(false);
                window.location.href = '/auth';
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default api;
